<template lang="pug">
div
  div(v-if="$vuetify.breakpoint.mobile" )
    // Horizontal scrollable menu for mobile
    div.overflow-x-auto
      div.d-flex.align-center.justify-start(style="width: max-content;")
        template(v-for="(menu, index) in sideMenu")
          div(:key="menu.id")
            router-link(:to="menu.to" v-slot="{ href, route, navigate, isActive, isExactActive }")
              div
                .px-4.py-2
                  a.text-sm.font-semibold.capitalize.no-underline(:href="href" @click="navigate" :class="isActive ? '' : 'neutral500--text'") {{ menu.title }}
                .bar-active(v-if="isActive")

    div.neutral300
      v-container.pa-5(style="max-width: 1600px")
        router-view

  div.d-flex(v-else)
    div.pa-8(style="width:280px; min-width:280px;")
      div(v-for="(menu, index) in sideMenu")
        router-link(:to="menu.to" v-slot="{ href, route, navigate, isActive, isExactActive }" :key="menu.id")
          .font-semibold.text-md.px-3.py-2.mb-2(@click="navigate" :class="isActive ? 'selected-bg round-sm' : 'cursor-pointer neutral500--text'") {{ menu.title }}
      v-btn.help-button.border-neutral500.button-Aa-small(outlined rounded @click="openUserback")
        .font-semibold.text-sm Need help?
    div.flex-grow-1.neutral200.h-screen
      div.neutral300
        v-container(style="max-width: 1600px")
          router-view
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InsightsHq',
  components: {},
  computed: {
    ...mapGetters({
      isHq: 'hq/getIsHq'
    }),
    sideMenu() {
      return [
        { id: 'today', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/today`, title: 'Today' },
        { id: 'sales', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/sales`, title: 'Sales' },
        { id: 'in-clinic', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/in-clinic`, title: 'In-clinic' },
        { id: 'appointment', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/appointments`, title: 'Appointments' },
        { id: 'payments', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/payments`, title: 'Payments' },
        { id: 'inventory', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/inventory`, title: 'Inventory' },
        { id: 'patients', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/patients`, title: 'Patients' },
      ]
    }
  },
  mounted () {
    const currentPath = this.$router.currentRoute.path
    if (currentPath === '/admin/clinic/insights' || currentPath === '/admin/hq/insights') {
      this.$router.replace(this.sideMenu[0].to).catch(() => {})
    }
  },
  methods: {
    openUserback() {
      this.$userback.open()
    }
  },
}
</script>

<style lang="scss" scoped>
.overflow-x-auto {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  // Hide scrollbar for webkit browsers
  &::-webkit-scrollbar {
    display: none;
  }

  // Hide scrollbar for Firefox
  scrollbar-width: none;
}

.bar-active {
  height: 2px;
  width: 100%;
  margin: auto;
  margin-top: -2px;
  background-color: #333;
}

.help-button {
  position: fixed;
  bottom: 32px;
  border: 1px solid var(--v-neutral400) !important;
}
</style>